import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../..";
import {
  assetApiAnalytics,
  AssetCountQuery,
} from "../../../services/analytics/assets";
import { CountClassifierMetric } from "../../../config/types";

interface AssetsMetricsState {
  classifier: CountClassifierMetric | null;
  total?: number;
  timeSeries: unknown | null;
}

const initialState: AssetsMetricsState = {
  classifier: {loading:true},
  timeSeries: null,
};

export const assetMetrics = createSlice({
  name: "AssetsMetrics",
  initialState,
  reducers: {
    updateClassifier: (state, action: PayloadAction<CountClassifierMetric>) => {
      state.classifier = action.payload;
    },
    updateTimeSeries: (state, action: PayloadAction<unknown>) => {
      state.timeSeries = action.payload;
    },
    updateTotalCount: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    startFetch: (state) => {
        if (state.classifier) {
            state.classifier.loading = true;
          } else {
            state.classifier = { loading: true };
          }

      },
    

  },
});

export const { updateClassifier, updateTotalCount, updateTimeSeries,startFetch } =
  assetMetrics.actions;

export const updateAssetCountClassifier =
  (query?: AssetCountQuery): AppThunk =>
  async (dispatch) => {
    try {
      const result = await assetApiAnalytics.getAssetCount(query ?? {});
      dispatch(
        updateClassifier({
          data: result.data,
          loading: false,
        })
      );
    } catch (err) {}
  };

export const updateAssetCountTotal = (): AppThunk => async (dispatch) => {
  try {
    const result = await assetApiAnalytics.getAssetCount({});

    if (result?.data) {
      dispatch(updateTotalCount(result.totalRecords ?? 0));
    }
  } catch (err) {}
};

export default assetMetrics.reducer;
